<template lang="pug">
  div
    section.content-header
      h1 {{pageTitle}}

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li
          router-link(:to="{name: 'appsuite-job'}") AppSuite データ連携設定
        li.active {{pageTitle}}

    section.content
      //- メッセージ
      app-messages(:errorMessages="errors", :successMessages="successes")

      form(ref="form", @submit.prevent="postData", novalidate)
        mixin btnbar
          .bcard-btnbar(class!=attributes.class)
            button.btn.btn-primary(type="submit") {{actionName}}
            |
            |
            router-link.btn.btn-default(:to="{name: 'appsuite-job'}") キャンセル
            template(v-if="this.id")
              | &nbsp;
              .btn-separator
              | &nbsp;
              button.btn.btn-danger(type="button" @click="isModalConfOpen = true", :disabled="item.status === JOB_STATUS.RUNNING" ) 削除

        +btnbar

        .box.box-widget

          .box-body
            .form-group
              label.control-label(for="bcard-appsuite-job-name") ジョブ名
                span.bcard-required (*)
              input#bcard-appsuite-job-name.form-control(type="text", name="job_name", v-model="item.job_name", :maxlength="maxlengths.job_name", required)

            .form-group
              label.control-label(for="bcard-appsuite-app-id") 連携先アプリ識別子
                span.bcard-required (*)
              input#bcard-appsuite-app-id.form-control(type="text", name="app_id", v-model="item.app_id", :maxlength="maxlengths.app_id", required)

            .help-block
              p.bcard-comments.text-info
                | ※ 連携先のアプリケーションの「アプリケーション識別子」を入力してください。
                br
                | 「アプリケーション識別子」は連携先のアプリケーションの [アプリケーション設定 > 詳細]内にある「API設定」タブを参照してください。
              p.bcard-comments.text-info
                | ※ 連携先アプリは「名刺バンク２名刺マスタ」テンプレートから作成されたアプリを指定してください。
                br
                | 「名刺バンク２名刺マスタ」テンプレートはXXXで配布されています。

            .form-group
              label.control-label データ連携エラー発生時の動作
              .radio.radio-rich
                label.radio-inline
                  input(type="radio", name="error_stop", v-model="item.error_stop", :value="app_flag.ON")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;エラーが発生したら連携処理を中断する
                label.radio-inline
                  input(type="radio" name="error_stop", v-model="item.error_stop", :value="app_flag.OFF")
                  span: i.fa.fa-dot-circle-o.fa-lg
                  | &nbsp;エラーを無視して最後まで連携処理を行う

            p.bcard-required ※ (*)は必須項目です。

        .box.box-widget
          .box-header.with-border
            .box-title 抽出条件

          .box-body
            .form-group
              label.control-label タグ
              loading(v-if="initLoading", :height="48")
              sel-tags(v-else, v-model="seltags", inputName="appsuite_job_tags[][id]", :view_mode="false", :mode="{isDispPv: false, canAddPv: false, isEdit: false}")
              .help-block
                p.bcard-comments.text-info ※ 選択したすべてのタグが付いている名刺を抽出します。

        +btnbar.-bottom

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(v-model="isModalConfOpen" type="danger")
      template(slot="title") ジョブの削除
      h4 ジョブを削除します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(@click="close(); deleteJob();") 削除
        button.btn.btn-default(@click.prevent="close();") キャンセル

</template>

<script>
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import mixinForm from '@/mixins/form'
import SelTags from '@/components/organisms/SelTags'
import Loading from '@/components/molecules/Loading'
import RepositoryFactory from '@/repositories/RepositoryFactory'

import { job_status } from './constants'

const AppSuiteJobRepository = RepositoryFactory.get('appsuitejob')

export default {
  name: 'AppsuiteJobsEdit',
  components: { AppModal, AppMessages, SelTags, Loading },
  mixins: [ mixinForm ],
  props: {
    id: {
      type: [String, Number],
      required: false,
      default: 0
    },
    item: {
      type: Object,
      required: false,
      default: function () {
        return {
          job_name: '',
          app_id: '',
          error_stop: '',
          status: job_status.PENDING
        }
      }
    }
  },
  data: function () {
    return {
      JOB_STATUS: job_status,
      pageTitle: this.id ? 'ジョブの変更' : 'ジョブの追加',
      actionName: this.id ? '変更' : '追加',
      isModalConfOpen: false,
      maxlengths: {},
      // タグ一覧取得フラグ
      getTagList: false,
      // 選択済みタグリスト
      seltags: [],

      initLoading: false
    }
  },
  created: function () {
    this.maxlengths = this.loadMaxlengths('AppsuiteJobs')

    // 変更時の初期データ
    if (this.id) {
      this.initLoading = true

      // 変更対象データ取得
      const vm = this
      AppSuiteJobRepository.get(this.id)
        .then(function (response) {
          const res = vm.getApiData(response).data

          vm.item.job_name = res.job_name
          vm.item.app_id = res.app_id
          vm.item.error_stop = res.error_stop
          vm.item.status = res.status

          for (let tag of res.appsuite_job_tags) {
            vm.seltags.push(tag)
          }
        })
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
        .finally(function () {
          vm.initLoading = false
        })
    }
    else {
      this.item.error_stop = this.app_flag.ON
    }
  },
  methods: {
    /**
     * 追加・更新処理
     */
    postData: function () {
      if (!this.checkFormValidity()) return

      const vm = this

      // 作成オプション
      let method = 'post'
      let params = []
      let formData = new FormData(this.$refs.form)

      // 更新オプション
      if (this.id) {
        method = 'put'
        params.push(this.id)
      }

      params.push(formData)

      // API実行
      AppSuiteJobRepository[method](...params)
        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'appsuite-job'})
          }
        })
        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    },
    /**
     * 削除処理
     */
    deleteJob: function () {
      const vm = this

      // 実行中は実施しない
      if (this.item.status === this.JOB_STATUS.RUNNING) return

      // 削除API実行
      AppSuiteJobRepository.delete(this.id)

        // 成功時処理
        .then(function (response) {
          // 一覧画面を表示
          if (vm.isApiSuccess(response)) {
            vm.$router.push({name: 'appsuite-job'})
          }
        })
        // エラー時処理
        .catch(function (error) {
          vm.setErrorMessage(error)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/appsuitejobs/Edit.vue